module.exports = __webpack_public_path__ + "img/bg_ft.319ecab4.png";